/**
 * Static mapping of top-level admin routes to Russian breadcrumb labels.
 *
 * Used by `Topbar` to produce human-readable breadcrumbs from the URL. Deeper
 * dynamic segments (`:trackId`, `:accountId`) will be resolved by their owning
 * pages once those tasks land — for v0.1 the foundation only needs first-level
 * labels.
 */

export const ROUTE_TITLES: Record<string, string> = {
  '/dashboard': 'Главная',
  '/catalog': 'Каталог',
  '/catalog/upload': 'Загрузка треков',
  '/catalog/tracks': 'Треки',
  '/presets': 'Подборки',
  '/presets/:presetId': 'Карточка подборки',
  '/tags': 'Словарь тегов',
  '/tag-dictionary': 'Словарь тегов',
  '/accounts': 'Аккаунты',
  '/accounts/:id': 'Карточка аккаунта',
  '/accounts/:accountId/venues/:venueId': 'Карточка заведения',
  '/selectors': 'Селекторы',
  '/promos': 'Промокоды',
  '/promos/new': 'Новый промокод',
  '/promos/:id': 'Карточка промокода',
  '/tickets': 'Обращения',
  '/analytics': 'Аналитика',
  '/audit': 'Журнал',
  '/notifications': 'Уведомления',
  '/settings': 'Настройки',
  '/settings/tariffs': 'Тарифы',
  '/settings/venue-formats': 'Категории заведений',
  '/settings/venue-formats/:id/schedule-template': 'Шаблон расписания',
  '/settings/notifications': 'Уведомления',
  '/settings/mood-compat': 'Mood-compat матрица',
  '/settings/users': 'Пользователи системы',
  '/settings/security': 'Безопасность',
  '/selector': 'Кабинет селектора',
  '/selector/home': 'Главная',
  '/selector/upload': 'Загрузка',
  '/selector/tracks': 'Мои треки',
  '/selector/presets': 'Мои подборки',
  '/selector/promo-codes': 'Мои промокоды',
  '/selector/payouts': 'Мои выплаты',
  '/selector/notifications': 'Уведомления',
  '/__demo__': 'Демо компонентов',
};
